import type { PillProps } from '@Components/pill';

export interface AiCreditsPillProps extends Omit<PillProps, 'size' | 'theme' | 'content'> {
  credits: number;
  theme: CreditsPillTheme;
  size: CreditsPillSize;
  tooltipArrowClassName?: string;
  showTooltip?: boolean;
  showCreditsCount?: boolean;
  onPaygUserClick?: VoidFunction;
  onClick?: VoidFunction;
}

export enum CreditsPillTheme {
  DEFAULT = 'default',
  ERROR = 'secondary',
  WARNING = 'warning',
}

export interface CreditsPillVariant {
  textColor: string;
  pillHoverClass: string;
}

export enum CreditsPillSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}
